import script from "./game-timer.vue?vue&type=script&setup=true&lang=ts"
export * from "./game-timer.vue?vue&type=script&setup=true&lang=ts"

import "./game-timer.vue?vue&type=style&index=0&id=ac4556c4&lang=scss"

const __exports__ = script;

export default __exports__